import React from 'react';
import ActivePlusSessionsPage from 'components/session/ActivePlusSessionsPage';

// "Mis sesiones" del cliente = sesiones PERSONALIZADAS (individuales con su plan).
// (Las grupales de Active Plus van en "Sesiones grupales" → ActivePlusSessionsPage mode="group".)
function ClientPersonalSessionsPage() {
  return <ActivePlusSessionsPage mode="individual" />;
}

export default ClientPersonalSessionsPage;
